// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-check-solid';

export const Component = () => (
  <path d='M15.745 6.37V.287l6.466 6.466v.048l.048.047h-6.035c-.335 0-.479-.143-.479-.478Zm.48 1.485h6.417v15.182c0 .431-.144.766-.431 1.054a1.408 1.408 0 0 1-1.054.43H3.484c-.43 0-.766-.143-1.005-.43-.288-.288-.431-.623-.479-1.054V1.485c.048-.431.191-.766.479-1.054C2.718.144 3.054 0 3.484 0H14.74l.048 6.37c0 .43.143.766.431 1.053.239.288.575.432 1.005.432h.001Zm1.484 4.405a.434.434 0 0 0-.144-.335.434.434 0 0 0-.335-.144.434.434 0 0 0-.335.144L11.29 17.48l-2.586-2.155c-.096-.096-.19-.144-.287-.144-.335 0-.527.192-.527.527 0 .144.048.287.192.335l2.92 2.49c.145.048.24.097.336.097.144 0 .24-.048.335-.144l5.89-5.89a.434.434 0 0 0 .145-.336Z' />
);

export const viewBox = '0 0 25 25';
